<template>
  <div class="responseble-info" v-loading="loading">
    <!-- 联系人手机号关联 -->
    <table class="small center">
      <tr class="table">
        <th>
          <span>联系人手机号关联</span>
          <div style="position: absolute; top: 0px; right: 0px; color: #4068f7; margin-right: 24px">
            <a class="el-icon-refresh" @click="reloadContactsTable()"
              >更新数据</a
            >
          </div>
        </th>
      </tr>
      <tr>
        <div class="table-list" style="padding: 0; margin: 0">
          <el-table :data="contactsTable" header-cell-style="background-color:#f5f7f9" border>
            <el-table-column label="类型">
              <template slot-scope="scope">
                {{
                  scope.row.relationType == null
                    ? placeholder
                    : scope.row.relationType
                }}
              </template>
            </el-table-column>
            <el-table-column label="关系">
              <template slot-scope="scope">
                {{
                  scope.row.relation == null ? placeholder : scope.row.relation
                }}
              </template>
            </el-table-column>
            <el-table-column label="姓名">
              <template slot-scope="scope">
                {{ scope.row.name == null ? placeholder : scope.row.name }}
              </template>
            </el-table-column>
            <el-table-column label="电话">
              <template slot-scope="scope">
                {{
                  scope.row.phoneNum == null ? placeholder : scope.row.phoneNum
                }}
              </template>
            </el-table-column>
            <el-table-column label="二要素验证">
              <template slot-scope="scope">
                {{
                  scope.row.verificationResult == null
                    ? placeholder
                    : scope.row.verificationResult
                }}
              </template>
            </el-table-column>
            <el-table-column label="关联用户">
              <template slot-scope="scope">
                {{
                  scope.row.relationUsername == null
                    ? placeholder
                    : scope.row.relationUsername
                }}
              </template>
            </el-table-column>
            <el-table-column label="类型">
              <template slot-scope="scope">
                {{
                  scope.row.userType == null ? placeholder : scope.row.userType
                }}
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="{ row }">
                <div v-if="row.userType == '商户'">
                  <router-link :to="`/home/merchantCheck/details/${row.id}`"
                    >查看</router-link
                  >
                </div>
                <div v-else-if="row.userType == '供应商' && row.no != null && row.no != ''">
                  <router-link
                    :to="`/home/supplierCheck/details/${row.id}/${row.no}`"
                    @click="change(row)"
                    >查看</router-link
                  >
                </div>
                <div v-else-if="row.userType == '供应商' && (row.no == null || row.no == '')">
                  <router-link
                    :to="`/home/supplierRegistered/details/${row.id}/${row.no}`"
                    @click="change(row)"
                    >查看</router-link
                  >
                </div>
                <div v-else>
                  {{placeholder}}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </tr>
    </table>

    <!-- 法人手机号关联 -->
    <table class="small center">
      <tr class="table">
        <th>
          <span>法人手机号关联</span>
          <div style="position: absolute; top: 0px; right: 0px; color: #4068f7; margin-right: 24px">
            <a class="el-icon-refresh" @click="reloadRelationCorpsTable()"
              >更新数据</a
            >
          </div>
        </th>
      </tr>
      <tr>
        <div class="table-list" style="padding: 0; margin: 0">
          <el-table
            :data="relationCorpsTable"
            header-cell-style="background-color:#f5f7f9"
            border
          >
            <el-table-column type="index" label="序号" />
            <el-table-column prop="userType" label="类型" />
            <el-table-column prop="relationUsername" label="店铺名称" />
            <el-table-column prop="corpName" label="法人姓名" />
            <el-table-column label="电话">
              <template slot-scope="scope">
                {{
                  scope.row.phoneNum == null ? placeholder : scope.row.phoneNum
                }}
              </template>
            </el-table-column>
            <el-table-column prop="relation" label="关系" />
            <el-table-column prop="name" label="操作">
              <template slot-scope="{ row }">
                <div v-if="row.userType == '商户'">
                  <router-link :to="`/home/merchantCheck/details/${row.id}`"
                    >查看</router-link
                  >
                </div>
                <div v-else-if="row.userType == '供应商' && row.no != null && row.no != ''">
                  <router-link
                    :to="`/home/supplierCheck/details/${row.id}/${row.no}`"
                    @click="change(row)"
                    >查看</router-link
                  >
                </div>
                <div v-else-if="row.userType == '供应商' && (row.no == null || row.no == '')">
                  <router-link
                    :to="`/home/supplierRegistered/details/${row.id}/${row.no}`"
                    @click="change(row)"
                    >查看</router-link
                  >
                </div>
                <div v-else>
                  {{placeholder}}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </tr>
    </table>

    <!-- 地理信息匹配 -->
    <table class="small center">
      <tr class="table">
        <th>
          <span>地理信息匹配</span>
        </th>
      </tr>
      <tr>
        <div class="table-list" style="padding: 0; margin: 0">
          <el-table
            :data="relationGeographicInfoTable"
            header-cell-style="background-color:#f5f7f9"
            border
          >
            <el-table-column prop="relationUsername" label="店铺名称" />
            <el-table-column prop="corpName" label="法人姓名" />
            <el-table-column label="电话">
              <template slot-scope="scope">
                {{
                  scope.row.phoneNum == null ? placeholder : scope.row.phoneNum
                }}
              </template>
            </el-table-column>
            <el-table-column label="身份证号码">
              <template slot-scope="scope">
                {{
                  scope.row.corpCertNo == null
                    ? placeholder
                    : scope.row.corpCertNo
                }}
              </template>
            </el-table-column>
            <el-table-column label="身份证号码对应地区">
              <template slot-scope="scope">
                {{
                  scope.row.corpCertAddress == null
                    ? placeholder
                    : scope.row.corpCertAddress
                }}
              </template>
            </el-table-column>
            <el-table-column label="营业执照地址">
              <template slot-scope="scope">
                {{
                  scope.row.merPermitAddr == null
                    ? placeholder
                    : scope.row.merPermitAddr
                }}
              </template>
            </el-table-column>
            <el-table-column prop="addressConsistency" label="同一地区" />
          </el-table>
        </div>
      </tr>
    </table>

    <!-- 周边用户匹配 -->
    <table class="small center">
      <tr class="table">
        <th style="padding: 10px;">
          <span>周边用户匹配</span>
          <div style="position: absolute; top: 8px; right: 0px;">
            <el-select v-model="circumOfUserTypeVal" style="width: 84px; background: #FFFFFF; padding-left: 10px; margin-right: 16px;" @change="setUserType1">
              <el-option
                v-for="item in circumOfUserTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value" >
              </el-option>
            </el-select>
            <el-select v-model="circumOfKmVal" style="width: 84px; background: #FFFFFF; padding-left: 6px; margin-right: 24px;" @change="setDistance1">
              <el-option
                v-for="item in circumOfKmOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value" >
              </el-option>
            </el-select>
            <!-- <select @change="setUserType1($event)">
              <option value="0">商户</option>
              <option value="1">供应商</option>
              <option value="2" selected="selected">全部</option>
            </select>
            <select @change="setDistance1($event)" style="margin-left: 16px">
              <option value="2000" selected="selected">2KM内</option>
              <option value="5000">5KM内</option>
              <option value="10000">10KM内</option>
            </select> -->
          </div>
        </th>
      </tr>
      <tr>
        <div class="table-list" style="padding: 0; margin: 0">
          <el-table :data="tableData1" header-cell-style="background-color:#f5f7f9" border>
            <el-table-column type="index" label="序号"/>
            <el-table-column label="类型" >
              <template slot-scope="scope">
                {{
                  scope.row.type == null || scope.row.type == ''
                    ? placeholder
                    : scope.row.type
                }}
              </template>
            </el-table-column>
            <el-table-column label="店铺名称" >
              <template slot-scope="scope">
                {{
                  scope.row.name == null || scope.row.name == ''
                    ? placeholder
                    : scope.row.name
                }}
              </template>
            </el-table-column>
            <el-table-column label="法人姓名" >
              <template slot-scope="scope">
                {{
                  scope.row.corpName == null || scope.row.corpName == ''
                    ? placeholder
                    : scope.row.corpName
                }}
              </template>
            </el-table-column>
            <el-table-column label="电话" >
              <template slot-scope="scope">
                {{
                  scope.row.phone == null || scope.row.phone == ''
                    ? placeholder
                    : scope.row.phone
                }}
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="{ row }">
                <div v-if="row.type == '商户'">
                  <router-link :to="`/home/merchantCheck/details/${row.id}`"
                    >查看</router-link
                  >
                </div>
                <div v-else-if="row.type == '供应商' && row.no != null && row.no != ''">
                  <router-link
                    :to="`/home/supplierCheck/details/${row.id}/${row.no}`"
                    @click="change(row)"
                    >查看</router-link
                  >
                </div>
                <div v-else>
                  <router-link
                    :to="`/home/supplierRegistered/details/${row.id}/${row.no}`"
                    @click="change(row)"
                    >查看</router-link
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </tr>
    </table>

    <!-- 同乡用户匹配 -->
    <table class="small center" v-show="addressConsistency == '否'">
      <tr class="table">
        <th style="padding: 10px;">
          <span>同乡用户匹配</span>
          <div style="position: absolute; top: 8px; right: 0px;">
            <el-select v-model="countrymenOfUserTypeVal" style="width: 84px; background: #FFFFFF; padding-left: 10px; margin-right: 16px;" @change="setUserType2">
              <el-option
                v-for="item in countrymenOfUserTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value" >
              </el-option>
            </el-select>
            <el-select v-model="countrymenOfKmVal" style="width: 84px; background: #FFFFFF; padding-left: 6px; margin-right: 24px;" @change="setDistance2">
              <el-option
                v-for="item in countrymenOfKmOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value" >
              </el-option>
            </el-select>
            <!-- <select @change="setUserType2($event)">
              <option value="0">商户</option>
              <option value="1">供应商</option>
              <option value="2" selected="selected">全部</option>
            </select>
            <select @change="setDistance2($event)" style="margin-left: 16px">
              <option value="2000" selected="selected">2KM内</option>
              <option value="5000">5KM内</option>
              <option value="10000">10KM内</option>
            </select> -->
          </div>
        </th>
      </tr>
      <tr>
        <div class="table-list" style="padding: 0; margin: 0">
          <el-table :data="tableData2" header-cell-style="background-color:#f5f7f9" border>
            <el-table-column type="index" prop="name" label="序号" />
            <el-table-column label="类型" >
              <template slot-scope="scope">
                {{
                  scope.row.type == null || scope.row.type == ''
                    ? placeholder
                    : scope.row.type
                }}
              </template>
            </el-table-column>
            <el-table-column label="店铺名称" >
              <template slot-scope="scope">
                {{
                  scope.row.name == null || scope.row.name == ''
                    ? placeholder
                    : scope.row.name
                }}
              </template>
            </el-table-column>
            <el-table-column label="法人姓名" >
              <template slot-scope="scope">
                {{
                  scope.row.corpName == null || scope.row.corpName == ''
                    ? placeholder
                    : scope.row.corpName
                }}
              </template>
            </el-table-column>
            <el-table-column label="电话" >
              <template slot-scope="scope">
                {{
                  scope.row.phone == null || scope.row.phone == ''
                    ? placeholder
                    : scope.row.phone
                }}
              </template>
            </el-table-column>
            <el-table-column label="身份证号码" >
              <template slot-scope="scope">
                {{
                  scope.row.certNo == null || scope.row.certNo == ''
                    ? placeholder
                    : scope.row.certNo
                }}
              </template>
            </el-table-column>
            <el-table-column label="距离" >
              <template slot-scope="scope">
                {{
                 scope.row.distance
                }}
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="{ row }">
                <div v-if="row.type == '商户'">
                  <router-link :to="`/home/merchantCheck/details/${row.id}`"
                    >查看</router-link
                  >
                </div>
                <div v-else-if="row.type == '供应商' && row.no != null && row.no != ''">
                  <router-link
                    :to="`/home/supplierCheck/details/${row.id}/${row.no}`"
                    @click="change(row)"
                    >查看</router-link
                  >
                </div>
                <div v-else>
                  <router-link
                    :to="`/home/supplierRegistered/details/${row.id}/${row.no}`"
                    @click="change(row)"
                    >查看</router-link
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    supId: {
      type: String,
      required: true,
    },
    details: Object
  },

  data() {
    return {
      circumOfUserTypeVal: '全部',
      circumOfUserTypeOptions: [
        {
          value: '2',
          label: '全部'
        },
        {
          value: '0',
          label: '供应商'
        },
        {
          value: '1',
          label: '商户'
        }
      ],
      circumOfKmVal: '2KM内',
      circumOfKmOptions: [
        {
          value: '2000',
          label: '2KM内'
        },
        {
          value: '5000',
          label: '5KM内'
        },
        {
          value: '10000',
          label: '10KM内'
        }
      ],
      countrymenOfUserTypeVal: '全部',
      countrymenOfUserTypeOptions: [
        {
          value: '2',
          label: '全部'
        },
        {
          value: '0',
          label: '供应商'
        },
        {
          value: '1',
          label: '商户'
        }
      ],
      countrymenOfKmVal: '2KM内',
      countrymenOfKmOptions: [
        {
          value: '2000',
          label: '2KM内'
        },
        {
          value: '5000',
          label: '5KM内'
        },
        {
          value: '10000',
          label: '10KM内'
        }
      ],
      contactsTable: [],
      relationCorpsTable: [],
      relationGeographicInfoTable: [],
      tableData1: [],
      tableData2: [],
      // 空白时的占位符
      placeholder: '-',
      loading: false,
      mode: 'channel',

      // 负责人信息
      details: [],
      channelList: [], // 渠道列表
      selectedChannel: '', // 选择的渠道
      showDialog: false,
      addressConsistency: '',
      certNo: '',
      type1: 2,
      distance1: 2000,
      type2: 2,
      distance2: 2000,
    }
  },

  computed: {
    replaceIndex() {
      return function (index) {
        return index < 10 ? '0' + index : index
      }
    },
    totalScope() {
      return this.details.reduce((prev, elem) => {
        prev += elem.scoring
        return prev
      }, 0)
    },
  },

  created() {
    //this.getPrincipalInfo() // 获取负责人信息
    this.listContacts() // 关系验证-相关联系人列表
    this.listRelationCorps() // 关系验证-相关法人列表
    this.listRelationGeographicInfo() // 关系验证-相关地理信息列表
    this.listUserMatchingInfor1() // 关系验证-周边用户匹配列表
  },

  methods: {
    //设置用户类型
    setUserType1(val){
      this.type1 = val
      this.listUserMatchingInfor1(this.type1,this.distance1)
    },
    setUserType2(val){
      this.type2 = val
      this.listUserMatchingInfor2(this.certNo,this.type2,this.distance2)
    },
    //设置用户距离
    setDistance1(val){
      this.distance1 = val
      this.listUserMatchingInfor1(this.type1,this.distance1)
    },
    setDistance2(val){
      this.distance2 = val
      this.listUserMatchingInfor2(this.certNo,this.type2,this.distance2)
    },

    // 更新关联联系人列表
    reloadContactsTable() {
      this.listContacts()
    },

    // 更新关联法人列表
    reloadRelationCorpsTable() {
      this.listRelationCorps()
    },

    // 关系验证-相关联系人列表
    listContacts() {
      const {
        supId,
        $store: { dispatch },
      } = this

      const dispatchEvent = 'T3/riskControlReview/listContacts'

      dispatch(dispatchEvent, { supId: supId }).then((res) => {
        this.contactsTable = res
      })
    },

    // 关系验证-相关法人列表
    listRelationCorps() {
      const {
        $store: { dispatch },
      } = this

      let phone = this.details.settlePhone;

      const dispatchEvent = 'T3/riskControlReview/listRelationCorps'

      dispatch(dispatchEvent, { phone }).then((res) => {
        this.relationCorpsTable = res
      })
    },

    // 关系验证-周边用户匹配列表
    listUserMatchingInfor1(type1,distance1) {
      const {
        supId,
        $store: { dispatch },
      } = this

      const dispatchEvent = 'T3/riskControlReview/listUserMatchingInfor'

      dispatch(dispatchEvent, {
        supId: supId,
        type: type1,
        distance: distance1
      }).then((res) => {
        this.tableData1 = res.data
      })
    },

    // 关系验证-相关地理信息列表
    listRelationGeographicInfo() {
      const {
        supId,
        $store: { dispatch },
      } = this
      const dispatchEvent = 'T3/riskControlReview/listRelationGeographicInfo'

      dispatch(dispatchEvent, { supId: supId }).then((res) => {
        this.relationGeographicInfoTable = res
        this.addressConsistency =
          this.relationGeographicInfoTable[0].addressConsistency
        this.certNo = this.relationGeographicInfoTable[0].corpCertNo
        if(this.addressConsistency == '否'){
          this.listUserMatchingInfor2(this.certNo)
        }
      })
    },

    // 关系验证-同乡用户匹配列表
    listUserMatchingInfor2(certNo,type2,distance2) {
      const {
        supId,
        $store: { dispatch },
      } = this

      const dispatchEvent = 'T3/riskControlReview/listUserMatchingInfor'

      dispatch(dispatchEvent, {
        supId: supId,
        certNO: certNo,
        type: type2,
        distance: distance2
      }).then((res) => {
        this.tableData2 = res.data
      })
    },

    // 获取负责人信息
    getPrincipalInfo() {
      const {
        supId,
        $store: { dispatch },
      } = this
      const dispatchEvent = 'T3/riskControlReview/getRelationship'

      dispatch(dispatchEvent, { supId: supId }).then((res) => {
        this.details = res
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/css/Common/tableList.scss';
@import '@/css/Common/detailsTable.scss';

table {
  margin-bottom: 24px;
}
</style>
